import axios from 'axios'

import { API_LCL_URL } from '../../constants'
import registerRequestInterceptor from './interceptors/request.interceptor'
import { registerResponseInterceptor } from './interceptors/response.interceptor'

export const LOADING_TIMEOUT = 60 * 1000

const axiosInstance = axios.create({
  baseURL: API_LCL_URL,
  headers: {
    'content-type': 'application/json',
    'Device-Type': 'Webapp',
    'x-product-line': 'lcl',
  },
  timeout: LOADING_TIMEOUT,
})

const registerIntercepters = (axiosObject) => {
  registerRequestInterceptor(axiosObject.interceptors.request)
  registerResponseInterceptor(axiosObject.interceptors.response)
}

registerIntercepters(axiosInstance)

export default axiosInstance
